<template>
  <div class="container-fluid bg-secondary vh-100">
    <div class="row justify-content-center h-100">
      <div class="col-md-5">
        <div class="row h-100">
          <div class="col-md-12 pt-4 bg-white">
            <!-- Church Logo -->
            <div class="text-center mb-2">
              <img
                :src="churchLogo"
                v-if="churchLogo"
                class="img-fluid"
                alt="Church Logo"
                style="width: 60px"
              />
              <img
                src="../../assets/dashboardlinks/churchcloud.png"
                v-else
                class="img-fluid"
                alt="Church Logo"
                style="width: 60px"
              />
            </div>

            <!-- Church Info -->
            <div class="text-center mb-4">
              <div class="font-weight-600 s-16 text-dak">
                {{
                  churchInfo && churchInfo.churchName
                    ? churchInfo.churchName
                    : ""
                }}
              </div>
              <p class="mb-2 tex-dak s-14">
                {{ churchInfo && churchInfo.address ? churchInfo.address : "" }}
              </p>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-center mb-4">
              <el-button
                style="
                  border-radius: 10px !important;
                  border: 1px solid #00000099 !important;
                "
                size="large"
                class="s-12 w-100"
                @click="openGoogleMaps"
              >
                <span class="text-dak fw-400">Get Direction</span>
              </el-button>
              <el-button
                color="#124191"
                size="large"
                style="border-radius: 10px !important"
                class="w-100"
              >
                <span class="text-white s-12 fw-400">I will Attend</span>
              </el-button>
            </div>

            <!-- Tabs -->
            <ul class="nav nav-tabs justify-content-center mb-0">
              <li class="nav-item" v-for="tab in tabs" :key="tab.key">
                <a
                  class="nav-link px-3"
                  :class="{ active: activeTab === tab.key }"
                  href="#"
                  @click.prevent="activeTab = tab.key"
                >
                  {{ tab.label }}
                </a>
              </li>
            </ul>

            <!-- Tab Content -->
            <div
              class="tab-content text-muted px-3 py-3"
              style="font-size: 14px"
            >
              <div v-if="activeTab === 'about'">
                <div
                  v-for="(item, index) in churchInfo.customAbouts"
                  :key="index"
                  class=""
                >
                  <div class="s-13 text-dak fw-500">{{ item.title }}</div>
                  <div class="s-13 text-dak fw-400">{{ item.details }}</div>
                </div>
              </div>
              <div v-else-if="activeTab === 'pastors'">
                <div class="row">
                  <div
                    class="col-md-6 col-6 col-sm-6 mb-3"
                    v-for="(item, index) in churchInfo.pastors"
                    :key="index"
                  >
                    <div class="pastor-card text-center">
                      <div class="pastor-image-container mb-2">
                        <img
                          v-if="item && item.photoUrl"
                          :src="item.photoUrl"
                          alt="image"
                          class="pastor-image"
                        />
                        <div v-else class="pastor-placeholder">
                          <i class="fas fa-user-circle"></i>
                        </div>
                      </div>
                      <div class="mt-3">
                        <div class="pastor-name s-14 font-weight-600">
                          {{ item?.name || "Pastor Name" }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="activeTab === 'serviceTime'">
                <div
                  class="row"
                  v-for="(item, index) in churchInfo.customAbouts"
                  :key="index"
                >
                  <div class="col-md-12" v-if="item.title === 'Services'">
                    <div class="row">
                      <div class="col-md-12 text-dak font-weight-600 s-14">
                        <div>{{ item.title }}</div>
                      </div>
                      <div
                        class="col-md-12 d-flex fw-400 s-12 text-dak justify-content-between"
                      >
                        <div>{{ item.details }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import axios from "@/gateway/backendapi";
import { useRoute } from "vue-router";

const churchLogo = ref(""); // Replace with logo path or leave blank to show fallback
const churchInfo = ref({});

const activeTab = ref("about");
const route = useRoute();
const getChurchProfile = async () => {
  try {
    const { data } = await axios.get(
      `/mobile/v1/MobileOnboarding/GetChurchMobile?TenantId=${route.params.id}`
    );

    churchInfo.value = data.returnObject;
    churchLogo.value = data.returnObject.logoUrl;
    console.log(churchInfo.value, "jjj");
  } catch (error) {
    console.log(error);
  }
};
getChurchProfile();
const openGoogleMaps = () => {
  if (churchInfo.value?.address) {
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(churchInfo.value.address)}`,
      '_blank'
    );
  }
};

const tabs = ref([
  { key: "about", label: "About" },
  { key: "pastors", label: "Pastors" },
  { key: "serviceTime", label: "Service Time" },
]);
</script>

<style scoped>
.nav-tabs .nav-link {
  font-size: 14px;
  color: #000;
  font-weight: 500;
}
.nav-tabs .nav-link.active {
  font-weight: bold;
  border: none;
  border-bottom: 2px solid #000;
  background-color: transparent;
}
.nav-tabs {
  border: none !important;
}
.pastor-card {
  padding: 1rem;
  border-radius: 8px;
  background: #f8f9fa;
  height: 100%;
}

.pastor-image-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: #e9ecef; */
}

.pastor-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pastor-placeholder {
  font-size: 3rem;
  color: #6c757d;
}

.pastor-name {
  color: #000000cc !important;
  margin-bottom: 0.25rem;
}
</style>
